<!-- 闲置寄存 -->
<template>
	<div class="con">
		<!-- 云当铺回收 -->
		<div class="leaveUnused">
			<div class="textCenter f28 pt25">云当铺寄存</div>
			<div class="textGary f14">业内领先团队评估检测，现场报价，专业买卖封管，资金流转高效</div>
			<div class="line"></div>
			<div class="onlineRecyclingImg">
				<img src="../../static/shop/deposite.png" />
			</div>
		</div>
		<div class="button f12" type="text" @click="showPopup">立即寄存
			<div class="rightIcon"><img src="../../static/shop/iconRight.png" /> </div>
		</div>
		<Popup :visible="popupVisible" :content="popupContent" @close="closePopup" />
	</div>
</template>
<script>
	import Popup from "../components/popup.vue";
	export default {
		components: {
			Popup
		},
		data() {
			return {
				popupVisible: false,
				popupContent: '这是一个弹窗'
			};
		},

		methods: {
			showPopup() {
				this.popupVisible = true;
			},
			closePopup() {
				this.popupVisible = false;
			}
		},
		computed: {
			computeArrowImg() {
				let screenHeight = document.body.clientWidth;
				if (screenHeight > 450) {
					return require("../../static/other/arrow.png");
				} else {
					return require("../../static/other/arrow_down.png");
				}
			}
		}
	}
</script>
<style lang="less" scoped>
	//2024-02-28 start
	.line {
		width: 35px;
		height: 2.5px;
		background: #FF354A;
		margin: auto;
		margin-top: 10px;
	}

	.onlineRecyclingImg {
		margin-top: 25px;
		display: flex;
		justify-content: center;
		width: 100%;

		img {
			height: auto;
			max-width: 80%;
		}
	}

	// 2024-02-28 end
	/* 云当铺回收 */
	.con {
		padding-bottom: 4rem;
	}

	.leaveUnused {
		width: 60%;
		margin: auto;
		margin-bottom: 1rem;

		.textGary {
			text-align: center;
			color: #999;
			margin-top: 0.5rem;
		}

		img {
			margin-left: 5%;
			margin-top: 1rem;
			margin-bottom: 2rem;
		}

	}

	.button {
		margin-bottom: 2rem;
		background-color: #E04747;
		color: #fff;
		text-align: center;
		width: 150px;
		height: 30px;
		line-height: 30px;
		margin: auto !important;
		border-radius: 60px;
		position: relative;

		.rightIcon {
			width: 20px;
			height: 20px;
			border-radius: 40px;
			background-color: #fff;
			position: absolute;
			right: 6px;
			top: 5px;
			display: flex;
			align-items: center;
			justify-content: center;

			img {
				width: 10px;
				display: block;
			}
		}
	}
</style>

<style lang="less">
	.indexButtom {
		background-color: #fff !important;
	}
</style>


// WEBPACK FOOTER //
// src/view/deposit.vue